import { render, staticRenderFns } from "./AddToAlbumModal.vue?vue&type=template&id=43c95eb5&lang=pug&"
import script from "./AddToAlbumModal.vue?vue&type=script&lang=js&"
export * from "./AddToAlbumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports